import { Card, Grid } from "@mui/material";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import { useFormik } from "formik";
import FormField from "components/MDFormField";
import React, { useContext, useEffect, useState } from "react";
import * as Yup from "yup";
import { updateProfile } from "Apis/signIn";
import ImageUploader from "components/MDImageUploader";
import { LoginFormContext } from "context/LoginFormContext";
import { userProfile } from "Apis/signIn";
import MDTelInput from "components/MDTelInput";
import SubmitButton from "components/SubmitButton";
import colors from "assets/theme/base/colors";

const BasicInfo = () => {
  const { setNotification, profileImage, setProfileImage } = useContext(LoginFormContext);
  const { sideNav } = colors;
  const [mobileNumber, setMobileNumber] = useState("+91");
  const initialValues = {
    first_name: "",
    last_name: "",
    email: "",
    mobile_number: "",
    image: "",
    role: "",
    country_code: "",
  };
  const ValidationSchema = Yup.object({
    first_name: Yup.string().required("First name is required !"),
    last_name: Yup.string().required("Last name is required !"),
    email: Yup.string().email("Invalid email address !").required("Email is required !"),
    mobile_number: Yup.string()
      .matches(/^[0-9]{10}$/, "Mobile number must be exactly 10 digits !")
      .required("Mobile number is required !"),
  });

  const getProfile = async () => {
    let response = await userProfile();
    if (response?.status === 200) {
      if (response?.data?.data) {
        formik.setValues({
          first_name: response?.data?.data?.first_name || "",
          last_name: response?.data?.data?.last_name || "",
          email: response?.data?.data?.email || "",
          mobile_number: response?.data?.data?.mobile_number || "",
          image: response?.data?.data?.admin_images[0]?.image || "",
          role: response?.data?.data?.role?.name || "",
          country_code: response?.data?.data?.country_code || "",
        });
        setProfileImage({ ...profileImage, url: response?.data?.data?.admin_images[0]?.image });
        setMobileNumber(
          "+" + response?.data?.data?.country_code + response?.data?.data?.mobile_number.toString()
        );
      }
    }
  };
  useEffect(() => {
    getProfile();
  }, []);

  const storedProfileImage = JSON.parse(localStorage.getItem("profileImage"));
  const handleSubmit = async (values) => {
    await formik.setFieldValue("image", profileImage?.name || storedProfileImage?.name || "");
    const updatedValues = {
      ...formik.values,
      image: profileImage?.name || storedProfileImage?.name || "",
    };
    let response = await updateProfile(updatedValues);
    if (response?.status === 200) {
      getProfile();
      setNotification({
        color: "success",
        icon: "check",
        title: "Success",
        content: response.data.message,
        open: true,
      });
    } else {
      setNotification({
        color: "error",
        icon: "cancel",
        title: "Error",
        content: response.data.message,
        open: true,
      });
    }
  };

  const formik = useFormik({
    initialValues: initialValues,
    validationSchema: ValidationSchema,
    onSubmit: handleSubmit,
  });

  const handlePhoneValueChange = (newPhone) => {
    setMobileNumber(newPhone?.numberValue);
    formik.setFieldValue("country_code", newPhone?.countryCallingCode);
    formik.setFieldValue("mobile_number", newPhone?.nationalNumber);
  };

  return (
    <>
      <MDBox component="form" onSubmit={formik.handleSubmit}>
        <Card id="profile" sx={{ marginBottom: "20px" }}>
          <MDBox p={2}>
            <Grid container spacing={3} alignItems="center">
              <Grid sx={{ paddingLeft: "25px", paddingTop: "12px" }}>
                <ImageUploader
                  // onImageUpload={handleImageUpload}.
                  hideLabel={true}
                  img={profileImage?.url}
                  folderName={"/admins"}
                  fileName={"image"}
                  formik={formik}
                  // getProfile={getProfile}
                  sx={{ width: "80px", height: "80px", borderRadius: "50px" }}
                />
              </Grid>
              <Grid sx={{ paddingLeft: "20px", paddingTop: "20px" }}>
                <MDBox height="100%" mt={1} lineHeight={1}>
                  <MDBox fontSize="20px" fontWeight="600" color={sideNav.textColor}>
                    {formik?.values?.first_name} {formik?.values?.last_name}
                  </MDBox>
                  <MDTypography variant="button" color="text" fontWeight="medium">
                    {formik?.values?.role}
                  </MDTypography>
                </MDBox>
              </Grid>
            </Grid>
          </MDBox>
        </Card>
        <Card id="basic-info" sx={{ overflow: "visible" }}>
          <MDBox p={3}>
            <MDBox fontSize="20px" fontWeight="600" color={sideNav.textColor}>
              Profile Info
            </MDBox>
          </MDBox>
          <MDBox pb={3} px={3}>
            <Grid container spacing={3}>
              <Grid item xs={12} sm={6}>
                <FormField
                  type="text"
                  value={formik.values.first_name}
                  label="First Name (તમારું નામ)"
                  name="first_name"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  required
                />
                {formik.touched.first_name && formik.errors.first_name && (
                  <MDBox sx={{ color: "red", fontSize: "12px", marginTop: "5px" }}>
                    {formik.errors.first_name}
                  </MDBox>
                )}
              </Grid>
              <Grid item xs={12} sm={6}>
                <FormField
                  type="text"
                  value={formik.values.last_name}
                  label="Last Name (અટક)"
                  name="last_name"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  required
                />
                {formik.touched.last_name && formik.errors.last_name && (
                  <MDBox sx={{ color: "red", fontSize: "12px", marginTop: "5px" }}>
                    {formik.errors.last_name}
                  </MDBox>
                )}
              </Grid>
              <Grid item xs={12} sm={6} sx={{ marginTop: "15px" }}>
                <FormField
                  type="email"
                  value={formik.values.email}
                  label="Email"
                  name="email"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  required
                />
                {formik.touched.email && formik.errors.email && (
                  <MDBox sx={{ color: "red", fontSize: "12px", marginTop: "5px" }}>
                    {formik.errors.email}
                  </MDBox>
                )}
              </Grid>
              <Grid item xs={12} sm={6} sx={{ marginTop: "10px" }}>
                <MDTelInput
                  name="mobile_number"
                  value={mobileNumber}
                  handleChange={(event) => handlePhoneValueChange(event)}
                  onBlur={formik.handleBlur}
                  label="Mobile No"
                  sx={{ width: "100%" }}
                  variant="standard"
                  required
                />
                {formik.touched.mobile_number && formik.errors.mobile_number && (
                  <MDBox sx={{ fontSize: "12px", color: "red", marginTop: "5px" }}>
                    {formik.errors.mobile_number}
                  </MDBox>
                )}
              </Grid>
            </Grid>
            <MDBox sx={{ marginTop: "40px", width: "100%", textAlign: "center" }}>
              <SubmitButton btnText="Update" type="submit" />
            </MDBox>
          </MDBox>
        </Card>
      </MDBox>
    </>
  );
};
export default BasicInfo;
